(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
function showToast(msg) {
  const toastDOMText = '<div class="toast">' +
    '<div class="content">' + (msg || '') + '</div>' +
  '</div>';
  $('body').append(toastDOMText);
  setTimeout(hiddenToast, 1000);
}

function hiddenToast() {
  $('body .toast').remove();
}

module.exports = {
  showToast
};

},{}],2:[function(require,module,exports){
const common = require('./source/common');
const index = require('./source/index');
const apiCache = require('./source/apiCache');
const product = require('./source/product');
const supply = require('./source/supply');
const detailMobile = require('./source/detailMobile');
const areaMap = require('./source/areaMap');
const productMap = require('./source/productMap');
const pagination = require('./source/pagination');
const LoginDialog = require('./source/login').LoginDialog;

const demonstrate = require('./source/demonstrate');

$(function () {
  $.ajaxPrefilter(function( options, originalOptions, jqXHR ) {
      options.xhrFields = {
          withCredentials: true
      }
  });
  common.init();
  window.loginDialog = new LoginDialog();
  // if (location.pathname.indexOf("/product/detail") != -1)
  {
    productMap.init();
    product.init();
  }
  // else if (location.pathname.indexOf("/product") != -1){
  //   product.init();
  // }
  // else if (location.pathname.indexOf("/area") != -1)
  {
    areaMap.init();
  }
  // else if (location.pathname.indexOf("/supply") != -1)
  {
    supply.init();
  }
  // else 
  {
    index.init();
  }
  detailMobile.init();
  apiCache.init();

  demonstrate.init();
});

},{"./source/apiCache":3,"./source/areaMap":4,"./source/common":5,"./source/demonstrate":7,"./source/detailMobile":8,"./source/index":11,"./source/login":12,"./source/pagination":13,"./source/product":14,"./source/productMap":16,"./source/supply":18}],3:[function(require,module,exports){
const init = () => {
  $('#clearCacheLink').on('click', () => {
    $.ajax({
      url: '/apiCache/clearAll',
      dataType: 'jsonp',
      success: (res) => {
        console.log(res);
      }
    })
  });
};
module.exports = {init};
},{}],4:[function(require,module,exports){
const pagination = require('./pagination');

function mapInit() {
    var map = new AMap.Map('mapContainer', {
        resizeEnable: true,
        zoom: 16,//级别
        center: [116.397428, 39.90923],
        viewMode: '3D'//使用3D视图
    });

    var lnglats = [
        [116.368904, 39.923423],
        [116.382122, 39.921176],
        [116.387271, 39.922501],
        [116.398258, 39.914600]
    ];
    var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
    for (var i = 0, marker; i < lnglats.length; i++) {
        var marker = new AMap.Marker({
            position: lnglats[i],
            map: map
        });
        marker.content =("<div>我是第"+ (i + 1) +"个Marker</div><div>电话：010-64733333</div>")
        marker.on('click', markerClick);
        // marker.emit('click', { target: marker });
    }

    function markerClick(e) {
        infoWindow.setContent(e.target.content);
        infoWindow.open(map, e.target.getPosition());
    }
    map.setFitView();
    
}
/**
 * 动态向产地列表内容区添加产地信息
 * @param
 *      products: [ProductionPlaceEntity]
 */
function appendProductionPlacesToDOM(products) {
  const divProductContent = $('.area-content-warpper .production-place-list');
  divProductContent.html('');
  const productionPlace = require('./productionPlace');
  const htmlText = productionPlace.productionPlaceDatas2List(products);
  divProductContent.append(htmlText);
  divProductContent.append('<div class="pagination"></div>');

  const bannerAPI = require("./index.js");
  bannerAPI.areaCarouselInit();
}
/**
 * 加载产地列表数据
 * @param {产地列表分页当前索引} nIndex
 * @param {数据加载完成回调} fn
 */
function loadPageData(nIndex, fn) {
  $.ajax({
    type: 'GET',
    url: '/area/list',
    data: {
      'pageIndex': nIndex
    },
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.datas) {
        appendProductionPlacesToDOM(response.data.datas);
        fn && fn(response.data);
      } else {
      }
    }
  });
}

function appendProductsToDOM(products) {
  const divProductContent = $('.area-detail-content div .product-warpper .product-content');
  divProductContent.html('');
  products.forEach(product => {
    let htmlText = '<div class="product">';
    htmlText += ('<a href="/product/detail/' + product.id + '">');
    htmlText += ('<img src="' + (product.picUrl && (typeof (product.picUrl) === 'string' ? product.picUrl : product.picUrl[0])) + '" />');
    htmlText += ('</a>');
    htmlText += ('<div class="product-name">' + product.name + '</div>');
    if (product.price) {
      htmlText += ('<div class="price">价格：');
      htmlText += ('<span class="price-icon">￥</span>');
      htmlText += ('<span>' + product.price + '</span>');
      htmlText += ('</div>');
    }
    if (product.supplierName) {
      htmlText += ('<div class="supplier">供应商：' + product.supplierName + '</div>');
    }
    htmlText += ('<div class="product-label">');
    if (product && product.labels) {
        product.labels.forEach(element => {
            var tmpSrc = ('<img style="width:auto;height: auto" src="/static/image/productDetail/');
            if (element == 9){
                tmpSrc += ('lvse.png" />');
            }
            else if (element == 4) {
                tmpSrc += ('baoxian.png" />');
            }
            else if (element == 1) {
                tmpSrc += ('chandi.png" />');
            }
            else if (element == 2) { 
                tmpSrc += ('hexinchandi.png" />');
            }
            else if (element == 3) {
                tmpSrc += ('jiance.png" />');
            }
            else if (element == 5) {
                tmpSrc += ('suyuan.png" />');
            }
            else if (element == 6) {
                tmpSrc += ('renzheng.png" />');
            }
            else if (element == 7) {
                tmpSrc += ('wugonghai.png" />');
            }
            else if (element == 8) {
                tmpSrc += ('youji.png" />');
            }
            else if (element == 'A' || element == 'a' || element == 10) {
                tmpSrc += ('dibiao.png" />');
            }
            else if (element == 'B' || element == 'b' || element == 11) {
                tmpSrc += ('fupen.png" />');
            }
            else {
                tmpSrc = null;
            }

            if (tmpSrc && tmpSrc.length > 0) {
                htmlText += tmpSrc;
            }
        });
    }
    htmlText += ('</div>');
    htmlText += ('</div>');
    divProductContent.append(htmlText);
  });
}

function loadProductionPlaceProducts(nIndex, fn) {
  const strProductionPlaceID = $('.content .area-detail-title .area-detail').attr('data');
  $.ajax({
    type: 'GET',
    url: '/area/products',
    data: {
      'pageIndex': nIndex,
      'id': strProductionPlaceID
    },
    success: function(response) {
      if (response && (response.errno == 0) && response.data && response.data.datas) {
        appendProductsToDOM(response.data.datas);
        fn && fn(response.data);
      } else {
      }
    }
  });
}

const init = () => {
  // mapInit();
  // PC端 产地列表分页点击
  let paginationPath = '.area-content-warpper div.pagination';
  pagination.bindItemClickEvent(paginationPath, null, loadPageData);
  // PC端 产地详情页中产品列表分页点击
  paginationPath = '.area-detail-content div div.pagination';
  pagination.bindItemClickEvent(paginationPath, null, loadProductionPlaceProducts);
};
module.exports = { init };

},{"./index.js":11,"./pagination":13,"./productionPlace":17}],5:[function(require,module,exports){
const init = () => {
  const globalData = require('./globalData');
  const eventBus = require('./eventBus');
  const $win = $(window);
  $win.on('resize', () => {
    const [width, height] = [$win.width(), $win.height()];
    globalData.set('windowSize', {width, height});
    eventBus.trigger('resize');
  });
};

/*
*   显示指定窗口
*   element：   要显示的元素
*   msg：   显示的消息
*   delay：   delay秒后，窗口关闭
*/
const displayElementView = function displayTipView (element, msg, color = '#ed1c00', delay = 2) {
  element.html(msg);
  element.css('visibility','visible');
  element.css('color',color);
  setTimeout(function (){
      element.css('visibility','hidden');
      element.html('');
  }, delay * 1000);
};

function showToast (strMsg, duration = 2000){
  const nLen = $("body div.zw-toast-pop").length;
  if (nLen == 0){
    const htmlText = '<div class="zw-toast-pop">' +
                      '<div class="zw-toast-inner">' + 
                        '<div class="zw-toast-inner-text"></div>' +
                      '</div>' +
                    '</div>';
    $("body").append(htmlText);
    $('body div.zw-toast-pop').on('click', function() {
      const toastElement = $('body div.zw-toast-pop');
      toastElement.remove();
    });
  }
  $("body div.zw-toast-pop .zw-toast-inner .zw-toast-inner-text").text(strMsg); 
  fadeOutToast(duration);
}
function fadeOutToast(duration = 2000) {
  const toastElement = $('body div.zw-toast-pop');
  toastElement.fadeIn();    
  setTimeout(function() {
    toastElement.fadeOut();    
  }, duration);
}

module.exports = {init, displayElementView, showToast};
},{"./eventBus":9,"./globalData":10}],6:[function(require,module,exports){

function isValidMobile(value) {
  if (value === '' || value === null || value === undefined) {
    return false;
  }
  const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
  if (!reg.test(value)) {
    return false;
  }
  return true;
}
function isValidTelephone(value) {
  if (value === '' || value === null || value === undefined) {
    return false;
  }
  const reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
  const reg2 = /^([0-9]{3,4})?[0-9]{7,8}$/;
  if (!reg.test(value) && !reg2.test(value)) {
    return false;
  }
  return true;
}
function isValidInt(value) {
  if (value === '' || value === null || value === undefined) {
    return false;
  }
  const reg = /^[0-9]*$/;
  if (!reg.test(value)) {
    return false;
  }
  return true;
}

module.exports = {
  isValidMobile,
  isValidTelephone,
  isValidInt
};

},{}],7:[function(require,module,exports){
// 2020-05-12 岳总需要的演示版本

const toast = require('../component/toast');

const appendFileItemToList = (name) => {
  const listDOMPath = '.allowance-content .header-operation .content .form-sheet form .file-list';
  const fileItemDOM = '<div class="file-row">' +
    '<img class="icon" src="static/image/demo/file-icon.png" />' +
    '<div>' + name + '</div>' +
    '<img class="status-flag" src="static/image/demo/check-radus-green.png" />' +
    '</div>';
  $(listDOMPath).append(fileItemDOM);
};

// button click event
/**
 * 专家咨询
 */
const onClickedCommitAdvice = () => {
  $('.expert-advice-content .header-operation .form-sheet input').each(function () {
    $(this).val('')
  });

  $('.expert-advice-content .header-operation .form-sheet textarea').each(function () {
    $(this).val('')
  });

  toast.showToast('保存成功');
};
/**
 * 保险服务
 */
const onClickedCommitClaim = () => {
  const btnAgreement = $('.claim-content .header-operation .form-sheet .row .check-btn .icon-selected');
  if (!btnAgreement || btnAgreement.length === 0) {
    toast.showToast('请阅读并同意投保须知和保险条款');
    return;
  }
  // 进度设置
  $('.claim-content .header-operation .progress #orderBtn2').addClass('btn-selected');
  $('.claim-content .header-operation .progress #orderBtn1').removeClass('btn-selected');
  // 
  $('.claim-content .header-operation .form-sheet').addClass('disabled');
  $('.claim-content .header-operation .form-sheet input').each(function () {
    $(this).attr('disabled', 'disabled');
  });
};

const onClickedUploadPic = (fileName, file) => {
  const _URL = window.URL || window.webkitURL;
  if (file && _URL) {
    const img = new Image();
    const src = _URL.createObjectURL(file);
    const picDOMText = '<img src="' + src + '" />';
    const domPath = '.claim-content .header-operation .form-sheet .row .content .pic-list';
    $(domPath).append(picDOMText);
  }
};

const init = () => {
  $('.borrow-content .header-operation .btn').on('click', function () {
    $('.apply-borrow-money').css('display', 'block');
  });
  $('.apply-borrow-money .apply-borrow-money-bk .content-panel .close').on('click', function () {
    $('.apply-borrow-money').css('display', 'none');
  });
  /*
  * 保险服务
  */
  // 点击 上传营业执照
  $('.claim-content .header-operation .form-sheet .row .content form #upload').on('change', function () {
    onClickedUploadPic(this.value, this.files && this.files.length > 0 && this.files[0]);
  });
  // 点击 条款 按钮
  $('.claim-content .header-operation .form-sheet .row .check-btn .icon').on('click', function () {
    if ($(this).hasClass('icon-selected')) {
      $(this).removeClass('icon-selected');
    } else {
      $(this).addClass('icon-selected');
    }
  });
  // 点击 提交 按钮
  $('.claim-content .header-operation .form-sheet .row .btn-submit').on('click', onClickedCommitClaim);
  /*
  * 农业补贴
  */
  // 点击 类型
  $('.allowance-content .header-operation .content .form-sheet .type .btn').each(function (index) {
    $(this).on('click', function () {
      // 之前选中的
      const iconPath = '.allowance-content .header-operation .content .form-sheet .type .btn-selected .icon';
      let iconImagePath = $(iconPath).attr('src');
      iconImagePath = iconImagePath.replace('-selected', '');
      $(iconPath).attr('src', iconImagePath);
      // 给现在选中的按钮 添加状态
      $(this).addClass('btn-selected').siblings().removeClass('btn-selected');
      iconImagePath = $(iconPath).attr('src');
      iconImagePath = iconImagePath.replace('.png', '-selected.png');
      $(iconPath).attr('src', iconImagePath);
    });
  });
  // 上传文件
  $('.allowance-content .header-operation .content .form-sheet form .file-list #upload').on('change', function () {
    const fileName = this.value && this.value.split('\\');
    if (fileName && fileName.length > 0) {
      appendFileItemToList(fileName[fileName.length - 1]);
    }
  });
  /*
  * 专家咨询
  */
  $('.expert-advice-content .header-operation .form-sheet .row .btn-submit').on('click', onClickedCommitAdvice);
};
module.exports = { init };

},{"../component/toast":1}],8:[function(require,module,exports){
//点击导航
function productHeaderInit() {
    let regNumber = /\d+/;
    var index = location.href.lastIndexOf("/");
    let obj = location.href.substring(index+1,location.href.length);
    if(location.href.indexOf('product')>=0 && regNumber.test(obj)){
      $(".header-wrap").addClass("no-show");
      $(".footer-wrap").addClass("no-show");
    }

    if(location.href.indexOf('area')>=0 && regNumber.test(obj)){
      $(".header-wrap").addClass("no-show");
      // $(".footer-wrap").addClass("no-show");
    }
    if(location.href.indexOf('supply')>=0){
      $(".release").addClass("no-show");
      // $(".footer-wrap").addClass("no-show");
    }
}

const init = () => {
    productHeaderInit();
};
module.exports = { init };
},{}],9:[function(require,module,exports){
let eventList = [];
module.exports = {
  on(eventName, callback){
    eventList.push({eventName, callback});
    return this;
  },
  off(eventName, callback){
    eventList = eventList.filter(item => {
      if (item.eventName === eventName) {
        if (!callback || (callback && callback === item.callback)) {
          return false;
        }
      }
      return true;
    });
    return this;
  },
  trigger(eventName, props){
    eventList.forEach(item => {
      if (item.eventName === eventName) {
        item.callback(props);
      }
    });
    return this;
  }
};
},{}],10:[function(require,module,exports){
const globalData = {};
module.exports = {
  get(key){
    return globalData[key];
  },
  set(key, value){
    globalData[key] = value;
    return this;
  }
};
},{}],11:[function(require,module,exports){

/**
 **************** PC端事件响应 ****************
 */

//移动端点击某个系统
function mobileSystemClick() {
  $('.mobile-body .system-list').on('click', '.system-item', function (event) {
    event.preventDefault();
    $('.mobile-body .system-list .system-item.active').removeClass('active');
    $(this).addClass('active');
    $.message.alert('请在电脑端进行登录');
  });
  //首页 供采池列表数据类型切换
  $(".supply-warpper-mobile .release-title a").each(function (index){
    $(this).click(function() {
      //点击采购
      if (index == 0){
        $(".supply-warpper-mobile .procurement-content-homepage").css("display", "block");
        $(".supply-warpper-mobile .supply-content-homepage").css("display", "none");
        $(".supply-warpper-mobile .more-supply a").attr("href", "/supply");
      }
      else{//点击供应
        $(".supply-warpper-mobile .procurement-content-homepage").css("display", "none");
        $(".supply-warpper-mobile .supply-content-homepage").css("display", "block");
        $(".supply-warpper-mobile .more-supply a").attr("href", "/supply/2");
      }
    });
  });
}
//头部登录按钮点击
function headerLoginInit() {
  //移动端暂时不支持登录
  $('.mobile-body .header .login-button').on('click', () => {
    $.message.alert('请在电脑端进行登录');
  });
}
//手机页面头部导航
function mobileHeaderNavInit() {
  $('.header .list-icon').on('click', () => {
    layer.open({
      type: 1,
      content: $('.nav-template').html(),
      anim: false,
      className: 'nav-layer',
    })
  });
}
//轮播图
function carouselImageInit() {
  $('.carousel-image-container').each(function (index) {
    const className = `carousel-image-index-${index}`;
    $(this).addClass(className);
    const slides = $(this).find('.swiper-slide');
    if (slides.length < 2) {
      $(this).find('.swiper-pagination').hide();
    }
    const swiper = new Swiper(`.${className}`, {
      loop: slides.length > 1,
      autoplay: slides.length > 1,
      pagination: {el: `.${className} .swiper-pagination`,},
    });
  });
}

//产地甄选轮播图
function areaCarouselInit() {
  $('.area-image-container').each(function (index) {
    const className = `area-image-index-${index}`;
    $(this).addClass(className);
    const slides = $(this).find('.swiper-slide');
    if (slides.length < 5) {
      $(this).find('.swiper-button-next').hide();
      $(this).find('.swiper-button-prev').hide();
    }
    const swiper = new Swiper(`.${className}`, {
      slidesPerView : 4,
      slidesPerGroup : 1,
      spaceBetween : 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });
}

// 点击导航
function navigationInit() {
  $('.nav a').each(function(index) {
    const href = $(this).attr('href');
    if (location.href.indexOf(href) >= 0 && href) {
      $('.nav a').removeClass('nav-check');
      $(this).addClass('nav-check');
    }
    $(this).click(function() {
      $('.nav a').eq(index).addClass('nav-check').siblings().removeClass('nav-check');
    });
  });
}



//返回顶部
function toTopInit() {
  $('.go-top').on('click', () => {
    $('html,body').animate({scrollTop: 0}, 500)
  });
}

//专家咨询 打开关闭切换
function expertConsultationToggle() {
  var $ec = $('.expert-consultation');
  $ec.on('click', '.consultation-online', () => {
    $ec.toggleClass('show-left');
  }).on('click', '.expert-consultation-close-icon', () => {
    $ec.removeClass('show-left');
  });
}
const init = () => {
  mobileSystemClick();
  headerLoginInit();
  mobileHeaderNavInit();
  carouselImageInit();
  toTopInit();
  expertConsultationToggle();
  navigationInit();
  areaCarouselInit();  
};
module.exports = {init,areaCarouselInit};
},{}],12:[function(require,module,exports){
/**
 * @param {登录成功后回调通知} callback
 */
function LoginDialog() {
  const that = this;
  // 显示登录弹窗
  $('.header .header-login div .left #btn-id-login').on('click', function() {
    const strToken = $('.login').attr('data');
    const strText = $('.header .header-login div .left #btn-id-login').text();
    if (strToken || strText === '退出登录') {
      that.logoutSystem();
    } else {
      that.show();
    }
  });
  // 隐藏登录弹窗
  $('.login .alert-dialog-bk .login-panel div.row-btn #btn-id-cancel').on('click', function() {
    that._hidden();
  });
  // 登录
  $('.login .alert-dialog-bk .login-panel div.row-btn #btn-id-ok').on('click', function() {
    that._loginSystem();
  });
  // 获取短信验证码
  $('div #btn-obtain-sms').on('click', function() {
    that._sendSMS();
  });
};
LoginDialog.prototype = {
  show: function(callback) {
    $('.login').css('display', 'block');
    $('.login-panel .row .col-80 input').each(function() {
      $(this).val('');
    });
    this.callback = callback;
  },
  _hidden: function() {
    $('.login').css('display', 'none');
  },
  _loginSystem: function() {
    const displayTipView = require('./common').displayElementView;
    var strMobile = $('input[name="mobile"]').val();
    var strSMS = $('input[name="sms"]').val();
    const tipElement = $('div .tip');
    if (strMobile == null || strMobile.length === 0) {
      displayTipView(tipElement, '请输入手机号码');
    } else if (strMobile.length !== 11) {
      displayTipView(tipElement, '请输入有效的手机号码');
    } else if (strSMS == null || strSMS.length === 0) {
      displayTipView(tipElement, '请输入短信验证码');
    } else {
      const that = this;
      $.ajax({
        type: 'GET',
        url: '/login',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {'mobile': strMobile, 'sms': strSMS},
        success: function(response) {
          if (response && (response.errno == 0) && response.data && response.data.result) {
            that._hidden();
            if (response.token) {
              $('.login').attr('data', response.token);
            }
            const elementLogin = $('.header-block .left #btn-id-login');
            if (elementLogin && elementLogin.length > 0) {
              elementLogin.html('退出登录');
            } else if (location.href.indexOf('/product/detail/') !== -1) {
              location.reload();
            }
            if (that.callback) {
              that.callback();
            }
          } else {
            let msg = '登录失败！';
            if (response && response.data && response.data.msg) {
              msg = response.data.msg;
            }
            displayTipView(tipElement, msg);
          }
        }
      });
    }
  },
  logoutSystem: function() {
    $.ajax({
      type: 'GET',
      url: '/login/logout',
      success: function(response) {
        if (response && (response.errno === 0) && response.data && !response.data.msg) {
          $('.header-block .left #btn-id-login').html('请登录');
          $('.login').attr('data', '');
        } else {
        }
      }
    });
  },
  _sendSMS: function() {
    const btnSMS = $('.login .alert-dialog-bk .login-panel div .col-80 #btn-obtain-sms');// 获取短信验证码按钮
    if (btnSMS.attr('class') === 'disable') {
      return;
    }
    const displayTipView = require('./common').displayElementView;
    var strMobile = $('input[name="mobile"]').val();
    const tipElement = $('div .tip');
    if (strMobile == null || strMobile.length === 0) {
      displayTipView(tipElement, '请输入手机号码');
    } else if (strMobile.length !== 11) {
      displayTipView(tipElement, '请输入有效的手机号码');
    } else {
      $.ajax({
        type: 'GET',
        url: '/login/sendSMS',
        data: {'mobile': strMobile},
        success: function(response) {
          if (response && (response.errno === 0)) {
            $('input[name="sms"]').html('');
            displayTipView(tipElement, '短信验证码发送成功！', '#7acc88');
            var nCount = 60;
            btnSMS.html(nCount);
            btnSMS.attr('class', 'disable');
            const tiemr = setInterval(function() {
              btnSMS.html(nCount);
              nCount--;
              if (nCount <= 0) {
                btnSMS.html('点击获取验证码');
                btnSMS.removeClass('disable');
                clearInterval(tiemr);
              }
            }, 1000);
          } else {
            displayTipView(tipElement, '短信验证码发送失败！');
            tipElement.html('短信验证码发送失败！');
          }
        }
      });
    }
  }
};
module.exports.LoginDialog = LoginDialog;

},{"./common":5}],13:[function(require,module,exports){

/**
 *  分页点击项处理方法
 * @param
 *      strPaginationPath : 分页器路径（如：".product-content div.pagination"）
 *      pageId : 当前点击项索引id
 *      fn：   回调
 * @returns 需要加载的数据页码
 */
function onClickedPageItem(strPaginationPath, pageId, fn) {
  let nCurPageIndex = parseInt($(strPaginationPath + ' ul li.active').attr('id'));
  if (pageId === 'first') {
    nCurPageIndex = 1;
  } else if (pageId === 'pre') {
    if (nCurPageIndex > 1) {
      nCurPageIndex -= 1;
    }
  } else if (pageId === 'less') {
    if (nCurPageIndex > 5) {
      nCurPageIndex -= 5;
    } else {
      nCurPageIndex = 1;
    }
  } else if (pageId === 'more') {
    nCurPageIndex += 4;
  } else if (pageId === 'next') {
    const pageCount = parseInt($(strPaginationPath + ' ul li#lastest').attr('maxId'));
    if (pageCount > nCurPageIndex) {
      nCurPageIndex += 1;
    }
  } else if (pageId === 'lastest') {
    nCurPageIndex = parseInt($(strPaginationPath + ' ul li#lastest').attr('maxId'));
  } else {
    nCurPageIndex = parseInt(pageId);
  }
  fn && fn(nCurPageIndex);
  return nCurPageIndex;
}
/**
 *  分页数据请求结果处理回填分页器
 * @param
 *      pageInfo: {
 *       nPageIndex:   当前页索引
 *       nPageSize:  每页数据数量
 *       nPageCount: 总页数
 *       nTotalCount: 总数据数量
 *      }
 *  domElement: 如：$('.area-detail-content div div.pagination')
 */
function appendPageToDOM(pageInfo, domElement, bindItemFn, clickedEvent) {
  const path = domElement.selector;
  domElement.html('');
  if (!pageInfo) {
    return;
  }
  domElement.append('<ul></ul>');
  domElement = domElement.children().first();
  let align = 1;
  if (pageInfo.nPageCount > 10) {
    if (pageInfo.nPageIndex > pageInfo.nPageCount - 4) {
      align = 3;
    } else if (pageInfo.nPageIndex >= 5) {
      align = 2;
    }
  }
  if (align === 1) {
    if (pageInfo.nPageCount > 10) {
      domElement.append('<li id="first"><<</li>');
      domElement.append('<li id="pre"><</li>');
      let itemStr;
      for (let i = 1; i <= 5; i++) {
        itemStr = '<li id="' + i + '"' + ((i === pageInfo.nPageIndex) ? ' class="active"' : '') + '>' + i + '</li>';
        domElement.append(itemStr);
      }
      domElement.append('<li id="more">...</li>');
      domElement.append('<li id="' + pageInfo.nPageCount + '">' + pageInfo.nPageCount + '</li>');
      domElement.append('<li id="next">></li>');
      domElement.append('<li id="lastest" maxId="' + pageInfo.nPageCount + '">>></li>');
    } else {
      for (let i = 1; i <= pageInfo.nPageCount; i++) {
        domElement.append('<li' + ((i === pageInfo.nPageIndex) ? ' class="active"' : '') + ' id=' + i + '">' + i + '</li>');
      }
    }
  } else {
    domElement.append('<li id="first"><<</li>');
    domElement.append('<li id="pre"><</li>');
    domElement.append('<li id="1">1</li>');
    domElement.append('<li id="less">...</li>');
    if (align === 2) {
      let itemStr;
      let indexTmp;
      for (let i = 0; i < 5; i++) {
        indexTmp = pageInfo.nPageIndex - 2 + i;
        itemStr = '<li id="' + indexTmp + '"' + ((indexTmp === pageInfo.nPageIndex) ? ' class="active"' : '') + '>' + indexTmp + '</li>';
        domElement.append(itemStr);
      }
      domElement.append('<li id="more">...</li>');
      domElement.append('<li id="' + pageInfo.nPageCount + '">' + pageInfo.nPageCount + '</li>');
    } else {
      let itemStr;
      let indexTmp;
      for (let i = 0; i < 5; i++) {
        indexTmp = pageInfo.nPageCount - 4 + i;
        itemStr = '<li id="' + indexTmp + '"' + ((indexTmp === pageInfo.nPageIndex) ? ' class="active"' : '') + '>' + indexTmp + '</li>';
        domElement.append(itemStr);
      }
    }
    domElement.append('<li id="next">></li>');
    domElement.append('<li id="lastest" maxId="' + pageInfo.nPageCount + '">>></li>');
  }
  bindItemClickEvent(path, bindItemFn, clickedEvent);
}

/**
 * 
 * @param {分页器路径} path 如：'.area-detail-content div div.pagination'
 * @param {*} bindItemFn
 * @param {页项按钮点击处理事件，clickedEvent(pageIndex, callback)} clickedEvent
 */
function bindItemClickEvent(path, bindItemFn, clickedEvent) {
  if (bindItemFn) {
    bindItemFn();
  } else if (path && clickedEvent) {
    $(path + ' ul li').each(function() {
      const id = $(this).attr('id');
      $(this).click(function() {
        const nPageIndex = onClickedPageItem('.procurement .procurement-warpper .pagination', id);
        clickedEvent(nPageIndex, function(pageInfo) {
          appendPageToDOM(pageInfo, $(path), null, clickedEvent);
        });
      });
    });
  }
}

module.exports = {
  onClickedPageItem,
  appendPageToDOM,
  bindItemClickEvent
};

},{}],14:[function(require,module,exports){
const common = require('./common');

/**
 ***************************** 网络请求 ******************************************
 */
/**
 * @param {数据页索引} nPageIndex
 * @param {回调} fn
 * @param {当前选择的产品分类ID} categoryIDs
 * @param {当前选择的产品标签ID} labelIDs
 * @param {当前选择的产地名称} citys
 */
function requestProductList(nPageIndex, fn, categoryIDs = [], labelIDs = [], citys = [], strProvince, categoryNames = [], labelNames = [], ) {
  $.ajax({
    type: 'POST',
    url: '/product/list',
    data: {
      'categoryIDs': JSON.stringify(categoryIDs),
      'labelIDs': JSON.stringify(labelIDs),
      'categoryNames': JSON.stringify(categoryNames),
      'labelNames': JSON.stringify(labelNames),
      'citys': JSON.stringify(citys),
      'province': strProvince,
      'pageIndex': nPageIndex
    },
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.datas) {
        if (fn) {
          fn(true, response.data);
        }
      } else {
        if (fn) {
          fn(false, response.data);
        }
      }
    }
  });
}

function requestProductListByKeyword(nPageIndex, fn, keyword) {
  $.ajax({
    type: 'POST',
    url: '/product/keywordList',
    data: {
      'keyword': keyword,
      'pageIndex': nPageIndex
    },
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.datas) {
        if (fn) {
          fn(true, response.data);
        }
      } else {
        if (fn) {
          fn(false, response.data);
        }
      }
    }
  });
}

/**
 * 根据产品标签ID 返回对于的图标名称
 */
function imageNameForProductLabel(productLabelID) {
    var strImageName;
    if (productLabelID == 9) {
        strImageName = 'lvse';
    }
    else if (productLabelID == 4) {
        strImageName = 'baoxian';
    }
    else if (productLabelID == 1) {
        strImageName = 'chandi';
    }
    else if (productLabelID == 2) {
        strImageName = 'hexinchandi';
    }
    else if (productLabelID == 3) {
        strImageName = 'jiance';
    }
    else if (productLabelID == 5) {
        strImageName = 'suyuan';
    }
    else if (productLabelID == 6) {
        strImageName = 'renzheng';
    }
    else if (productLabelID == 7) {
        strImageName = 'wugonghai';
    }
    else if (productLabelID == 8) {
        strImageName = 'youji';
    }
    else if (productLabelID == 10 || productLabelID == 'A' || productLabelID == 'a') {
        strImageName = 'dibiao';
    }
    else if (productLabelID == 11 || productLabelID == 'B' || productLabelID == 'b') {
        strImageName = 'fupen';
    }
    else {
        return '';
    }
    return strImageName + '.png';
}

// const request = require('./request');
const pagination = require('./pagination');

/**
 * 动态向产品内容区添加产品
 * @param   
 *      products: [ProductEntity]
 */
function appendProductToDOM(products) {
  const divProductContent = $('.content .product-content .content');
  divProductContent.html('');
  const htmlText = products2HtmlText(products);
  divProductContent.append(htmlText);
  divProductContent.append('<div class="pagination"></div>');
}
/**
 * 通过网络加载产品列表数据
 * @param   
 *      categoryID: 产品分类ID  [string]
 *      labelID:   [string]
 *      city:   [string]
 *      strProvince:   string
 */
function getProductList(nPageIndex, fn, categoryID, labelID = [], city = [], strProvince, categoryNames, labelNames = []) {
  const elementTotal = $('.product-content-warpper .product-content .title');

  var strMsg;
  requestProductList(nPageIndex, function(bResult, data) {
    strMsg = '为您找到' + data.nTotalCount + '条产品';
    elementTotal.html(strMsg);
    appendProductToDOM(data.datas);
    pagination.appendPageToDOM(data, $('.product-content-warpper .product-content div.pagination'), bindPageItemClickEvent);
    fn && fn();
  }, categoryID, labelID, city, strProvince, categoryNames, labelNames);
}

function getProductListByKeyword(nPageIndex, fn, keyword) {
  const elementTotal = $('.product-content-warpper .product-content .title');
  let strMsg;
  requestProductListByKeyword(nPageIndex, function(bResult, data) {
    strMsg = '为您找到' + (data.nTotalCount || 0) + '条产品';
    elementTotal.html(strMsg);
    if (bResult && data.datas) {
      appendProductToDOM(data.datas);
      pagination.appendPageToDOM(data, $('.product-content-warpper .product-content div.pagination'), null, onClickedKeywordFilter);
    } else {
      appendProductToDOM([]);
      pagination.appendPageToDOM({}, $('.product-content-warpper .product-content div.pagination'), null, onClickedKeywordFilter);
    }
    fn && fn();
  }, keyword);
}
/**
 * 筛选产品列表
 */
function onClickedFilter(nPageIndex = 1, fn) {
  const {categoryIDs, categoryNames} = window.productFilter.extractProductCategoryIDs();
  const {labelIDs, labelNames} = window.productFilter.extractProductLabelIDs();
  const strProvince = window.productFilter.extractProvinceName();
  const arrCitys = window.productFilter.extractCityNames();
  getProductList(nPageIndex, fn, categoryIDs, labelIDs, arrCitys, strProvince, categoryNames, labelNames);
}

function onClickedKeywordFilter(index = 1) {
  const keyword = $('.pc-product-filter-panel .product-keyword input').val();
  getProductListByKeyword(index, function() {
    window.productFilter.reset();
  }, keyword);
}

/**
 * 点赞
 */
function onClickedStar(city) {
  var strProductID = $('.content .product-detail-content').attr('id');
  $.ajax({
    type: 'POST',
    url: '/product/star',
    data: {
      'productID': strProductID
    },
    success: function(response) {
      if (response && (response.errno == 0) && response.data && response.data.result) {
        var eleDiv = $('.introduce .left .view span #star span');
        var star = eleDiv.html();
        eleDiv.html(++star);
      } else {
      }
    }
  });
}
/**
 * 踩
 */
function onClickedUnstar(city) {
    var strProductID = $('.content .product-detail-content').attr('id');
    $.ajax({
        type:'POST',
        url: '/product/unstar',
        data:{
            'productID':strProductID
        },
        success:function (response){
            if (response && (response.errno == 0) && response.data && response.data.result){
                var eleDiv = $('.introduce .left .view span #unstar span');
                var star = eleDiv.html();
                eleDiv.html(++star);
            }
            else {
            }
        }
    } );
}

// 分页器事件绑定
function bindPageItemClickEvent() {
  $('.product-content-warpper .product-content div.pagination ul li').each(function(index) {
    const id = $(this).attr('id');
    $(this).click(function() {
      pagination.onClickedPageItem('.product-content-warpper .product-content div.pagination', id, onClickedFilter);
    });
  })
}

/**
 * 点击 直达购买 按钮处理
 */
function onClickedPurchase() {
  // const btnElement = $('.product-detail-content .introduce .right .btn');
  // var url = btnElement.attr('data');
  // if (url) {
  //     if ((url.indexOf('https://') == -1) && (url.indexOf('http://') == -1)) {
  //         url = 'https://' + url;
  //     }
  //     window.open(url);
  // }
  // else {
  //     url = btnElement.attr('dataH5');
  //     url = 'http://system.center.jgwcjm.com/apiInterface/common/qrCode?content=' + url;
  //     window.open(url); 
  // }
}
function onClickedMobilePurchase() {
  const btnElement = $('.product-detail-mobile .buy');
  var url = btnElement.attr('dataH5');
  if (url) {
    if ((url.indexOf('https://') === -1) && (url.indexOf('http://') === -1)) {
      url = 'https://' + url;
    }
    window.open(url);
  }
}
/**
 * 显示证书查看图片弹窗
 */
function displayCertificationImages(index) {
    var arrCertifications = extractCertificationImages();
    if ($('.mobile-body').length > 0) {//手机端
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = [];
        var nPictureIndex = 0;
        for (var i = 0; i < arrCertifications.length; i++) {
            var urls = arrCertifications[i];
            if (index > i) {
                nPictureIndex += urls.length;
            }
            urls.forEach(url => {
                items.push({src:url, w:400, h:600});
            });
        }
        // define options (if needed)
        var options = {
            // optionName: 'option value'
            // for example:
            index: nPictureIndex // start at first slide
        };
        
        // Initializes and opens PhotoSwipe
        var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    }
    else {
        $('.product-detail-alert').css('display', 'block');
        const imageViewerElement = $('.product-detail-alert .alert-dialog-bk img.content');
        imageViewerElement.attr('src', arrCertifications[index][0]);
        imageViewerElement.attr('dataX', index);
        imageViewerElement.attr('dataY', 0);
    }
}
/**
 * 提取证书图片
 * @ret: [[url]]
 */
function extractCertificationImages() {
    var arrCertifications = [];
    var domNameCertificationImage = '.product-detail-content .introduce .right .report div span';
    if ($(domNameCertificationImage).length == 0){
        domNameCertificationImage = '.product-detail-mobile .title-detail .product-detail-certification .product-certification-item';
    }
    if ($(domNameCertificationImage).length > 0){
        $(domNameCertificationImage).each(function (index){
            var name = $(this).text();
            var url = $(this).attr('data');
            var arrUrl = url.split(',http');
            for (var i = 1; i < arrUrl.length; i++) {
                arrUrl[i] = 'http' + arrUrl[i];
            }
            arrCertifications.push(arrUrl);
        });
    }
    return arrCertifications;
}
function displayNextCertificationImage(){
    var arrCertifications = extractCertificationImages();
    const imageViewerElement = $('.product-detail-alert .alert-dialog-bk img.content');
    var nIndex = imageViewerElement.attr('dataX');
    var nIndexY = imageViewerElement.attr('dataY');
    if (nIndexY < arrCertifications[nIndex].length - 1) {
        nIndexY++;
        imageViewerElement.attr('src', arrCertifications[nIndex][nIndexY]);
        imageViewerElement.attr('dataY', nIndexY);
    }
    else if (nIndex < arrCertifications.length - 1) {
        nIndex++;
        nIndexY = 0;
        imageViewerElement.attr('src', arrCertifications[nIndex][nIndexY]);
        imageViewerElement.attr('dataY', nIndexY);
        imageViewerElement.attr('dataX', nIndex);
    }

}
function displayPreCertificationImage() {
  var arrCertifications = extractCertificationImages();
  const imageViewerElement = $('.product-detail-alert .alert-dialog-bk img.content');
  var nIndex = imageViewerElement.attr('dataX');
  var nIndexY = imageViewerElement.attr('dataY');
  if (nIndexY > 0) {
    nIndexY--;
    imageViewerElement.attr('src', arrCertifications[nIndex][nIndexY]);
    imageViewerElement.attr('dataY', nIndexY);
  } else if (nIndex > 0) {
    nIndex--;
    nIndexY = arrCertifications[nIndex].length - 1;
    imageViewerElement.attr('src', arrCertifications[nIndex][nIndexY]);
    imageViewerElement.attr('dataY', nIndexY);
    imageViewerElement.attr('dataX', nIndex);
  }
}

// 点击导航
function productTagInit() {
  const ProductFilter = require('./product/productFilter').ProductFilter;
  window.productFilter = new ProductFilter(function(citys, categoryIDs, labelIDs, province) {
    onClickedFilter(1, function() {
      $('.pc-product-filter-panel .product-keyword .ui-searchbar #id_keyword').val('');
    });
  });
  // pc端产品列表 搜索框
  const keywordDOM = $('.pc-product-filter-panel .product-keyword .ui-searchbar #id_keyword');
  keywordDOM && (keywordDOM.keypress(function(e) {
    let keyCode = null;
    if (e.which) {
      keyCode = e.which;
    } else if (e.keyCode) {
      keyCode = e.keyCode;
    }
    if (keyCode === 13) {
      onClickedKeywordFilter();
      return false;
    }
    return true;
  }));
  $('.pc-product-filter-panel .product-keyword .ui-searchbar .icon').on('click', () => onClickedKeywordFilter());

  $('.product-detail-content .introduce .left div span #star').click(onClickedStar);
  $('.product-detail-content .introduce .left div span #unstar').click(onClickedUnstar);
  bindPageItemClickEvent();
}

function productDetailInit() {
  //
  $('.product-detail-content .introduce .right .btn').on('click', onClickedPurchase);

  if ($('.product-detail-content .introduce .right .report div').length > 0) {
    $('.product-detail-content .introduce .right .report div').each(function(index) {
      $(this).click(function() {
        displayCertificationImages(index);
      });
    });
  } else if ($('.product-detail-mobile .title-detail .product-detail-certification .product-certification-item').length > 0) {
    $('.product-detail-mobile .title-detail .product-detail-certification .product-certification-item').each(function(index) {
      $(this).click(function() {
        displayCertificationImages(index);
      });
    });
  }
  // 证书查看弹窗关闭按钮
  $('.product-detail-alert .alert-dialog-bk .close-btn').on('click', function() {
    $('.product-detail-alert').css('display', 'none');
  });
  // 证书查看翻页
  $('.product-detail-alert .alert-dialog-bk .swiper-button-prev').on('click', displayPreCertificationImage);
  // 证书查看翻页
  $('.product-detail-alert .alert-dialog-bk .swiper-button-next').on('click', displayNextCertificationImage);

  // 手机端 直达购买 点击事件
  $('.product-detail-mobile .buy').on('click', onClickedMobilePurchase);
}

const init = () => {
  productTagInit();
  productDetailInit();

  var strRoute = '/product';
  if (location.href.indexOf(strRoute) + strRoute.length === location.href.length) {
    // 当前为产品列表页
  }
};
module.exports = { init };

function products2HtmlText(products) {
  let htmlText = '<div class="product-list">';
  products && products.length > 0 && products.forEach(product => {
    htmlText += product2Cell(product);
  });
  htmlText += ('</div>');
  return htmlText;
}
// 将产品信息转化为DOM元素
function product2Cell(product) {
  let htmlText = '<div class="product-list-item">';
  // 图片
  htmlText += ('<a href="/product/detail/' + product.id + '"><div>');
  if (typeof (product.picUrl) === 'string' && product.picUrl.length > 0) {
    htmlText += ('<img src="' + (product.picUrl || '') + '" />');
  } else if (typeof (product.picUrl) === 'object' && product.picUrl.length > 0) {
    htmlText += ('<img src="' + (product.picUrl[0] || '') + '" />');
  } else {
    htmlText += ('<img src="/static/image/wutupian-px.png" />');
  }
  htmlText += ('</div></a>');
  // 名称
  htmlText += ('<div class="product-name">' + (product.name || '') + '</div>');
  // 价格
  htmlText += ('<div class="price"' + (product.price ? '' : ' style="visibility:hidden"') + '>');
  htmlText += ('<div class="price-label">价格：</div>');
  htmlText += ('<div class="price-icon">￥</div>');
  htmlText += ('<div class="price-text">' + (product.price || '') + '</div>');
  htmlText += '</div>';
  // 供应商
  htmlText += ('<div class="supplier"' + (product.supplierName ? '' : ' style="display:none"') + '>');
  htmlText += ('供应商：' + (product.supplierName || ''));
  htmlText += ('</div>');
  // 标签
  htmlText += ('<div class="product-label">');
  product && product.labels && (htmlText += productLabel2HtmlText(product.labels));
  htmlText += ('</div>');

  htmlText += ('</div>');
  return htmlText;
}

function productLabel2HtmlText(labels) {
  let htmlText = '';
  labels && labels.forEach(element => {
    let icon = '';
    if (element == 1) {
      icon = 'chandi';
    } else if (element == 2) {
      icon = 'hexinchandi';
    } else if (element == 3) {
      icon = 'jiance';
    } else if (element == 4) {
      icon = 'baoxian';
    } else if (element == 5) {
      icon = 'suyuan';
    } else if (element == 6) {
      icon = 'renzheng';
    } else if (element == 7) {
      icon = 'wugonghai';
    } else if (element == 8) {
      icon = 'youji';
    } else if (element == 9) {
      icon = 'lvse';
    } else if (element === 'A' || element === 'a' || element == 10) {
      icon = 'dibiao';
    } else if (element === 'B' || element === 'b' || element == 11) {
      icon = 'fupen';
    }
    if (icon && icon.length > 0) {
      htmlText += ('<img src="/static/image/productDetail/' + icon + '.png" />');
    } else {
      htmlText += ('<div class="product-label-item">' + element + '</div>');
    }
  });
  return htmlText;
}

},{"./common":5,"./pagination":13,"./product/productFilter":15}],15:[function(require,module,exports){
/**
 * @param {筛选完成后回调} okCallback {回调参数：cityNames, categoryIDs, lableIDs, provinceName}
 */
function ProductFilter(okCallback) {
  var _this = this;
  //产品分类
  $(".pc-product-filter-panel div .product-categorys div").each(function(index) {
    $(this).click(function() {
      _this._onClickedProductCategoryItem(index, ".pc-product-filter-panel div .product-categorys div");
    });
  });
  // 产品标签
  $(".pc-product-filter-panel div .product-labels div").each(function(index) {
    $(this).click(function() {
      _this._onClickedProductLabelItem(index, ".pc-product-filter-panel div .product-labels div");
    });
  });
  //产地筛选
  $(".pc-product-filter-panel div .product-provinces div").each(function(index) {
    $(this).click(function() {
      _this._onClickedProductProvinceItem(index, ".pc-product-filter-panel div .product-provinces div");
    });
  });
  this.okCallback = okCallback;
  this._bindCityItemClickEvent();
}
ProductFilter.prototype = {
  _onClickedOk : function() {
    var citys = this.extractCityNames();
    var productCategorys = [];
    var productLabels = [];
    var bIsProductListPage = $(".pc-product-filter-panel div .product-citys div").length > 0;
    if (bIsProductListPage) 
    {
      productCategorys = this.extractProductCategoryIDs().categoryIDs;
      productLabels = this.extractProductLabelIDs().labelIDs;
    }
    var strProvince = this.extractProvinceName();   
    if (this.okCallback)
    {
      this.okCallback(citys, productCategorys, productLabels, strProvince);
    }

    this._serializeCitys();
    this._serializeSelectedProvince();
    this._serializeSelectedProductCategory();
    this._serializeSelectedProductLabel();
  },
  /**
   * 产品分类项选择
   * @param {左侧菜单索引} index 
   * @param {产品分类项选择器} selectorPath 
   */
  _onClickedProductCategoryItem : function(index, selectorPath){
    if (index == 0) {
      $(selectorPath).eq(index).addClass("tag-checked").siblings().removeClass("tag-checked");
    }
    else {
      if ($(selectorPath).eq(index).attr("class")) {
        $(selectorPath).eq(index).removeClass("tag-checked");
        if ($(selectorPath + ".tag-checked").length == 0) {
            $(selectorPath).eq(0).addClass("tag-checked");
        }
      }
      else {
        $(selectorPath).eq(index).addClass("tag-checked");
        $(selectorPath).eq(0).removeClass("tag-checked");
      }
    }
    this._onClickedOk();
  },
  /**
   * 产品标签项选择
   */
  _onClickedProductLabelItem : function(index, selectorPath){
      this._onClickedProductCategoryItem(index, selectorPath);
  },
  /**
   * 省份项选择
   */
  _onClickedProductProvinceItem : function(index, selectorPath){
      if ($(selectorPath).eq(index).attr("class")) 
      {
          return;
      }
      // 清除城市列表
      var strCityElementRootPath = ".pc-product-filter-panel div .product-citys";
      $(strCityElementRootPath).html('');
      // 选中当前选择的省份
      $(selectorPath).eq(index).addClass("tag-checked").siblings().removeClass("tag-checked");

      var strProvince = this.extractProvinceName();
      if (index > 0) 
      {
          var _this = this;
          this._requestCityList(function (bResult, datas){
              if (bResult){
                  _this._appendCitysToDOM(datas);
              }
              _this._onClickedOk();
          }, strProvince);
      } else if (index === 0) {
          this._onClickedOk();
      }
  },
  /**
   * 城市项选择
   */
  _onClickedProductCityItem : function(index, selectorPath){
  },
  /**
   * 提取当前选择的产品分类
   * @returns : [id]
   */
  extractProductCategoryIDs : function() {
    const strElementCategoryItemPath = ".pc-product-filter-panel div .product-categorys div.tag-checked";
    var categoryIDs = [];
    const categoryNames = [];
    $(strElementCategoryItemPath).each(function (index) {
      const id = $(this).attr("id") || '';
      if (id.length > 0) {
        categoryIDs.push(id);
        const title = $(this).text() || '';
        categoryNames.push(title);
      }
    });
    return {categoryIDs, categoryNames};
  },
  /**
   * 提取当前选择的产品标签
   * @returns : [id]
   */
  extractProductLabelIDs : function() {
      const strElementLabelItemPath = ".pc-product-filter-panel div .product-labels div.tag-checked";
      const labelIDs = [];
      const labelNames = [];
      $(strElementLabelItemPath).each(function (index) {
        const id = $(this).attr("id") || '';
        if (id.length > 0) {
          labelIDs.push(id);
          const title = $(this).text() || '';
          labelNames.push(title);
        }
      });
      return {labelIDs, labelNames};
  },
  /**
   * 提取当前选择的产地
   * @returns : string
   */
  extractProvinceName : function() {
      var strProvince = $(".pc-product-filter-panel div .product-provinces div.tag-checked").text();
      if (!strProvince || strProvince.length == 0 || strProvince == "全选") 
      {
          strProvince = "";
      }
      return strProvince;
  },
  /**
   * 提取当前选择的城市
   * @returns : [string]
   */
  extractCityNames : function() {
      var citys = [];
      const strElementCityPath = ".pc-product-filter-panel div .product-citys div";
      var strProvince = $(".pc-product-filter-panel div .product-provinces div.tag-checked").text();
      if (strProvince) 
      {
          if (strProvince != "全选") 
          {
              if ($(strElementCityPath + ".tag-checked").length > 0)
              {
                  $(strElementCityPath + ".tag-checked").each(function (index){
                      var strCity = $(this).text();
                      if (strCity)
                      {
                          citys.push(strCity);
                      }
                  });
              }
          }
      }
      return citys;
  },
  /**
   * 保存当前加载的城市 和 选择的城市索引
   */
  _serializeCitys : function(){
    var arrCitys = [];
    var arrSelectedCityIndexs = [];
    var elementCitys = $(".product-filter .product-filter-content .right-submenu .product-places .city li");
    elementCitys.each(index => {
      var strCity = elementCitys.eq(index).text();
      arrCitys.push(strCity);
      if (elementCitys.eq(index).attr("class") == "checked"){
        arrSelectedCityIndexs.push(index);
      }
    });
    this.arrCitys = arrCitys;
    this.arrSelectedCityIndexs = arrSelectedCityIndexs;
  },
  /**
   * 保存当前选择的省份索引
   */
  _serializeSelectedProvince : function (){
      var elementCitys = $(".product-filter .product-filter-content .right-submenu .product-places .province li");
      var that = this;
      elementCitys.each(index => {
          if (elementCitys.eq(index).attr("class") == "checked"){
              that.nCurSelectedProvinceIndex = index;
          }
      });
  },
  /**
   * 保存当前选择的产品分类索引
   */
  _serializeSelectedProductCategory : function (){
      var elementCategoryItems = $(".product-filter .product-filter-content .right-submenu .product-categorys li");
      if (elementCategoryItems.length > 0)
      {
          var arrSelectedIndexs = [];
          elementCategoryItems.each(index => {
              if (elementCategoryItems.eq(index).attr("class") == "checked"){
                  arrSelectedIndexs.push(index);
              }
          });
          this.arrSelectedProductCategoryIndexs = arrSelectedIndexs;
      }
  },
  /**
   * 保存当前选择的产品标签索引
   */
  _serializeSelectedProductLabel : function (){
    var elementLabelItems = $(".product-filter .product-filter-content .right-submenu .product-labels li");
    if (elementLabelItems.length > 0)
    {
      var arrSelectedIndexs = [];
      elementLabelItems.each(index => {
        if (elementLabelItems.eq(index).attr("class") == "checked"){
          arrSelectedIndexs.push(index);
        }
      });
      this.arrSelectedProductLabelIndexs = arrSelectedIndexs;
    }
  },
  _deserializeCitys : function(){
      this._appendCitysToDOM(this.arrCitys);

      var elementCitys = $(".product-filter .product-filter-content .right-submenu .product-places .city li");
      this.arrSelectedCityIndexs.forEach(index => {
          elementCitys.eq(index).addClass("checked");
      });
  },
  _deserializeSelectedProvine : function(){
      var elementProvinces = $(".product-filter .product-filter-content .right-submenu .product-places .province li")
      elementProvinces.eq(this.nCurSelectedProvinceIndex).addClass("checked").siblings().removeClass("checked");
  },
  _deserializeSelectedProductCategory : function(){
      var elementCategoryItems = $(".product-filter .product-filter-content .right-submenu .product-categorys li");
      if (elementCategoryItems.length > 0)
      {
          this.arrSelectedProductCategoryIndexs.forEach(index => {
              elementCategoryItems.eq(index).addClass("checked");
          });
      }
  },
  _deserializeSelectedProductLabel : function(){
    var elementLabelItems = $(".product-filter .product-filter-content .right-submenu .product-labels li");
    if (elementLabelItems.length > 0)
    {
      this.arrSelectedProductLabelIndexs.forEach(index => {
        elementLabelItems.eq(index).addClass("checked");
      });
    }
  },
  /**
   * 动态向产地子级列表中添加内容
   * @param   
   *      citys: [string]
   */
  _appendCitysToDOM : function(citys) {
      var cityElement = $(".pc-product-filter-panel div .product-citys")
      if (cityElement.length > 0)
      {
          // 手机端 城市数据填充
          cityElement.html('');
          if (citys) 
          {
              if (!Array.isArray(citys)) 
              {
                  citys = [citys];
              }
              citys.forEach(function (city){
                  if (city) 
                  {
                      var htmlText = '<div>' + city + '</div>';
                      cityElement.append(htmlText);
                  }
              });
              this._bindCityItemClickEvent();
          }
      }    
  },
  /**
   * 绑定二级行政区点击事件
   */
  _bindCityItemClickEvent : function() {
      const _this = this;
      var strParentElementPath = ".pc-product-filter-panel div .product-citys div";
      if ($(strParentElementPath).length > 0){
          $(strParentElementPath).each(function (index) {
              $(this).click(function () {
                  if ($(strParentElementPath).eq(index).attr("class")) {
                      $(strParentElementPath).eq(index).removeClass("tag-checked");
                  }
                  else {
                      $(strParentElementPath).eq(index).addClass("tag-checked");
                  }
                  _this._onClickedOk();
              });
          });       
      }
  },
  /**
   * 获取指定省份下的城市
   * @param {*} strProvince 
   * @param {数据加载成功后回调} fn ：【fn(bResult, datas), datas:[string]】
   */
  _requestCityList : function(fn, strProvince = "") {
      $.ajax({
          type:'POST',
          url: '/base/region',
          data:{
              "province":strProvince
          },
          success:function (response){
              if (response && (response.errno == 0) && response.data){                
                  fn(true, response.data);
              }
              else {
                  fn(false, response.data);
              }
          }
      } );
  },

  // 重置当前选择的项
  reset: function() {
    $('.pc-product-filter-panel div .product-categorys div').eq(0).addClass('tag-checked').siblings().removeClass('tag-checked');
    $('.pc-product-filter-panel div .product-labels div').eq(0).addClass('tag-checked').siblings().removeClass('tag-checked');
    $('.pc-product-filter-panel div .product-provinces div').eq(0).addClass('tag-checked').siblings().removeClass('tag-checked');
  }
}

module.exports.ProductFilter = ProductFilter;

},{}],16:[function(require,module,exports){

/*
*   根据最后一级获取经纬度
*/
function getLocationcenter(country, elemId, lnglats) {
    AMap.plugin("AMap.Geocoder", function () {
        const geocoder = new AMap.Geocoder({
            // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
            city: "全国"
        });
        geocoder.getLocation(country, (status, result) => {
            if (status === "complete" && result.info === "OK") {
                // result中对应详细地理坐标信息
                let mapCenter = [
                    result.geocodes[0].location.lng,
                    result.geocodes[0].location.lat
                ];
                var map = new AMap.Map(elemId, {
                    zoomEnable: true,
                    zoom: 11, //级别
                    center: mapCenter, //中心点坐标
                    viewMode: "3D" //使用3D视图
                });

                if (lnglats) {
                    var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
                    let areaData = [];
                    areaMessage.subPlaces.map((item, index) => {
                        if (item.longitude && item.latitude) {
                            areaData.push(item);
                        }
                    })
                    for (var i = 0, marker; i < lnglats.length; i++) {
                        var marker = new AMap.Marker({
                            position: lnglats[i],
                            map: map
                        });
                        marker.id = areaData[i].id;
                        marker.content =
                            "<div>基地：" + areaData[i].name + "</div><div>地址：" + areaData[i].address + "</div><div>电话：" + areaData[i].contactsTel + "</div><div>负责人：" + areaData[i].principalName;
                        marker.on("click", markerClick);
                    }

                    function markerClick(e) {
                        infoWindow.setContent(e.target.content);
                        infoWindow.open(map, e.target.getPosition());

                        $.ajax({
                            type: 'get',
                            url: '/product/areaProduct',
                            data: {
                                "baseId": e.target.id,
                            },
                            success: function (response) {
                                if (response && (response.errno == 0) && response.data) {
                                    var str = "";
                                    $.each(response.data, function (key, value) {
                                        
                                        str += '<div style="margin:20px 20px 20px 50px">' + 
                                                  '<div style="display:inline-block;vertical-align:top;margin-right: 25px;">' + 
                                                    '<img style="width:51px;height:51px" src="' + (value.picUrl ? (typeof (value.picUrl) === 'string' ? value.picUrl : value.picUrl[0]) : '') + '"/>' + 
                                                  '</div>' +
                                                '<div style="display:inline-block;line-height:26px;width:240px">' + 
                                                  '<div style="display:inline-block;font-size:15px;font-weight:bold">' + value.name +'</div>' +
                                                  '<div style="font-size:12px">'+ value.organizationFullName +'</div>' + 
                                                '</div>' + 
                                            '</div>';

                                        $('#areaProduct').html(str);
                                    });
                                }
                                else {
                                }
                            }
                        })

                    }

                    map.setFitView();
                }
            }
        });
    });
}
function setLocationCenter(longitude, latitude, elemId) {
  const map = new AMap.Map(elemId);
  map.setCenter([longitude, latitude]);
}

function productMapInit() {
  let country;
  let locationText;

  if ($(".product-detail-mobile .content-area-map").length > 0){
    country = $(".product-detail-mobile .content-area-map").attr("data");
    if (!country) {
      locationText = $('.product-detail-mobile #contentAreaMap').attr("location");
    }
  } else {
    country = $('#country').text();
    if (!country) {
      locationText = $('#countryLocation').text();
    }
  }
  if (country) {
    getLocationcenter(country, "contentAreaMap");
  } else if (locationText && locationText.length > 2) {
    const [longitude, latitude] = locationText.split(',');
    setLocationCenter(longitude, latitude, 'contentAreaMap');
  }
}

function mapInit() {
    let regNumber = /\d+/;
    var index = location.href.lastIndexOf("/");
    let obj = location.href.substring(index + 1, location.href.length);
    if (location.href.indexOf("area") >= 0 && regNumber.test(obj)) {
        var country = $('#country').text();
        if ($(".area-detail-mobile .area-introduce .map-introduce .area-content-mobile .map-content").length > 0){
            country = $(".area-detail-mobile .area-introduce .map-introduce .area-content-mobile .map-content").attr("data");
        }
        let lnglats = [];
        areaMessage && areaMessage.subPlaces && areaMessage.subPlaces.map((item, index) => {
            if (item.longitude && item.latitude) {
                lnglats.push([item.longitude, item.latitude]);
            }
        })
        getLocationcenter(country, "mapContainer", lnglats);
    }
}

/**
 * 手机端 产品详情 点赞 事件响应
 */
function onClickedMobileStar(){
    var strProductID = $(".product-detail-mobile").attr("id");
    $.ajax({
        type:'POST',
        url: '/product/star',
        data:{
            "productID":strProductID
        },
        success:function (response){
            if (response && (response.errno == 0) && response.data && response.data.result){
                var eleDiv = $(".product-detail-mobile .title-detail .product-star #star span");
                var star = eleDiv.html();
                eleDiv.html(++star);
            }
            else {
            }
        }
    } );
}
/**
 * 手机端 产品详情 反点赞 事件响应
 */
function onClickedMobileUnstar(){
    var strProductID = $(".product-detail-mobile").attr("id");
    $.ajax({
        type:'POST',
        url: '/product/unstar',
        data:{
            "productID":strProductID
        },
        success:function (response){
            if (response && (response.errno == 0) && response.data && response.data.result){
                var eleDiv = $(".product-detail-mobile .title-detail .product-star #unstar span");
                var star = eleDiv.html();
                eleDiv.html(++star);
            }
            else {
            }
        }
    } );
}
/**
 * 手机端 产品详情 登录 事件响应
 */
function onClickedMobileLogin(){
    window.loginDialog.show();
}
const init = () => {
    productMapInit();
    mapInit();
    // 手机端
    if ($(".product-detail-mobile .title-detail .product-star").length > 0){
        // 点赞
        $(".product-detail-mobile .title-detail .product-star #star").on("click", onClickedMobileStar);
        $(".product-detail-mobile .title-detail .product-star #unstar").on("click", onClickedMobileUnstar);
        $(".product-detail-mobile .product-detail .product-detail-mobile a").on("click", onClickedMobileLogin);
    }
    else {
        $(".main .content-wrap .content .product-detail-content .introduce .right .price-area div span #btn-id-login").on("click", function (){
            window.loginDialog.show();
        });
    }
};
module.exports = { init };

},{}],17:[function(require,module,exports){
/**
 * @param {产地数据列表} productionPlaces
 */
function productionPlaceDatas2List(productionPlaces) {
  let htmlText = '';
  productionPlaces.forEach(element => {
    htmlText += (productionPlaceData2Cell(element));
  });
  return htmlText;
}
function productionPlaceData2Cell(place) {
  let htmlText = '<div class="production-place-item">';
  htmlText += (
    '<a href="/area/' + place.id + '/' + (place.name || (place.privince || '')) + '"><div>' +
    '<img src="' + place.picUrl + '" />' +
    '</div></a>'
  );
  htmlText += (
    '<div class="place-name">' +
    '<span>' + place.name + '</span>' +
    '</div>'
  );

  htmlText += ('</div>');
  return htmlText;
}

/**
 * PC 产地甄馆
 */
module.exports = {
  productionPlaceDatas2List
};

},{}],18:[function(require,module,exports){
// const request = require('./request');
const pagination = require('./pagination');
const utils = require('./common/utils');
/**
 * 推送需求信息到服务器
 * @param {需求类型，1：采购；2：供应} nType
 * @param {需求名称} strName
 * @param {需求内容} strContent
 * @param {发布成功或失败回调} callback
 */
function publishRequirement2Server(nType, strName, strContent, mobile, productionPlace, description, fn) {
  const param = {
    'title': strName
  };
  mobile && (param.contactMobile = mobile);
  strContent && (param.needNum = strContent);
  productionPlace && (param.place = productionPlace);
  description && (param.content = description);

  $.ajax({
    type: 'POST',
    url: (nType === 1 ? '/supply/procurement' : '/supply/supplier'),
    data: param,
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.result) {
        nType === 1 ? onClickedProcurementPageItem(1) : onClickedSupplierPageItem(1);
        fn && fn(true);
      } else {
        const msg = (response && response.data && response.data.msg) || '';
        fn && fn(false, msg);
      }
    }
  });
}

function getElementDomValue(path, value) {
  const doms = $(path);
  if (value !== undefined && value !== null) {
    doms.val(value);
  }
  return doms && doms.val();
}
/*
*   PC端点击发布需求(采购、供应)
*/
function onClickedPublishRequirement() {
  const displayTipView = require('./common').displayElementView;

  var nType;
  $('.release-title a').each(function(index) {
    var classNames = $('.release-title a').eq(index).attr('class');
    if (classNames) {
      if (index === 0) {
        nType = 1;
      } else {
        nType = 2;
      }
    }
  });
  const tipElement = $('.release .tip');
  let name;
  let productionPlace;
  let amount;
  let mobile;
  let content;
  let fnCallback;
  switch (nType) {
    // eslint-disable-next-line no-lone-blocks
    case 1: {
      name = getElementDomValue('.release .purchase-form .release-report-row #purchase-name');
      if (!(name && name.length > 0)) {
        displayTipView(tipElement, '请输入采购产品名称');
        return;
      }
      amount = getElementDomValue('.release .purchase-form .release-report-row #productCount');
      if (!(amount && amount.length > 0)) {
        displayTipView(tipElement, '请输入采购需求数量');
        return;
      } /* else if (!utils.isValidInt(amount)) {
        displayTipView(tipElement, '请输入有效的需求数量');
        return;
      } */
      mobile = getElementDomValue('.release .purchase-form .release-report-row #purchase-mobile');
      if (!(mobile && mobile.length > 0)) {
        displayTipView(tipElement, '请输入联系电话');
        return;
      } else if (!utils.isValidMobile(mobile) && !utils.isValidTelephone(mobile)) {
        displayTipView(tipElement, '请输入有效的联系电话');
        return;
      }
      content = getElementDomValue('.release .purchase-form .release-report-row #introduce');
      fnCallback = function(bResult, msg) {
        if (bResult) {
          displayTipView(tipElement, '添加成功', 'green');
          getElementDomValue('.release .purchase-form .release-report-row #purchase-name', '');
          getElementDomValue('.release .purchase-form .release-report-row #productCount', '');
          getElementDomValue('.release .purchase-form .release-report-row #purchase-mobile', '');
          getElementDomValue('.release .purchase-form .release-report-row #introduce', '');
        } else {
          displayTipView(tipElement, msg || '添加失败了！');
        }
      };
    }
      break;
    // eslint-disable-next-line no-lone-blocks
    case 2: {
      name = getElementDomValue('.release .supply-form .release-report-row #productName');
      if (!(name && name.length > 0)) {
        displayTipView(tipElement, '请输入供应产品名称');
        return;
      }
      productionPlace = getElementDomValue('.release .supply-form .release-report-row #productionPlace');
      if (!(productionPlace && productionPlace.length > 0)) {
        displayTipView(tipElement, '请输入产品产地');
        return;
      }
      amount = getElementDomValue('.release .supply-form .release-report-row #amount');
      if (!(amount && amount.length > 0)) {
        displayTipView(tipElement, '请输入产品数量');
        return;
      } /* else if (!utils.isValidInt(amount)) {
        displayTipView(tipElement, '请输入有效的产品数量');
        return;
      } */
      mobile = getElementDomValue('.release .supply-form .release-report-row #mobile');
      if (!(mobile && mobile.length > 0)) {
        displayTipView(tipElement, '请输入联系电话');
        return;
      } else if (!utils.isValidMobile(mobile) && !utils.isValidTelephone(mobile)) {
        displayTipView(tipElement, '请输入有效的联系电话');
        return;
      }
      content = getElementDomValue('.release .supply-form .release-report-row #introduce');
      if (!(content && content.length > 0)) {
        displayTipView(tipElement, '请输入产品介绍');
        return;
      }
      fnCallback = function(bResult, msg) {
        if (bResult) {
          displayTipView(tipElement, '添加成功', 'green');
          getElementDomValue('.release .supply-form .release-report-row #productName', '');
          getElementDomValue('.release .supply-form .release-report-row #productionPlace', '');
          getElementDomValue('.release .supply-form .release-report-row #amount', '');
          getElementDomValue('.release .supply-form .release-report-row #mobile', '');
          getElementDomValue('.release .supply-form .release-report-row #introduce', '');
        } else {
          displayTipView(tipElement, msg || '添加失败了！');
        }
      };
    }
      break;
  }
  publishRequirement2Server(nType, name, amount, mobile, productionPlace, content, fnCallback);
}
/**
 * 动态向产品内容区添加产品
 * @param
 *      PageData
 */
function convertProcurementData2DOM(procurement) {
  let htmlText = '<div class="supply">';
  htmlText += (
    '<div class="product-name">' +
      '<span class="supply-time">' + procurement.date + '</span>' +
      '<span class="supply-icon"></span>' +
    '</div>'
  );
  htmlText += ('<div class="product-content">');
  htmlText += (
    '<div class="name">产品名称：' + (procurement.title || '') + '</div>' +
    '<div class="amount">需求数量：' + (procurement.amount || '') + '</div>' +
    '<div class="contact">联系方式：' + (procurement.contactMobile || '') + '</div>'
  );
  if (procurement.content && procurement.content.length > 0) {
    htmlText += ('<div class="content">详情：' + procurement.content + '</div>');
  }
  htmlText += '</div>';
  htmlText += (
    '<div class="product-bottom">' +
      '<span style="visibility: hidden"><i class="iconlocation"></i> 广西桂林泰士特</span>' +
      '<span class="mobile" style="visibility:' + (procurement.mobile ? 'visible' : 'hidden') +'"><i class="iconphone"></i>' + procurement.mobile + '</span>' +
    '</div>'
  );
  htmlText += ('</div>');
  return htmlText;
};
function convertProcurementData2H5DOM(procurement) {
  let htmlText = '<div class="content-supply">' +
                    '<div class="title-supply">' +
                    '<div class="supply-type-supply">购</div>' +
                    '<span>' + (procurement.title || '') + '</span>' +
                    '<span>' + (procurement.date || '') + '</span>' +
                  '</div>';

  htmlText += (
    '<div class="content-supply">' +
      '<div class="amount">需求数量：' + (procurement.amount || '') + '</div>' +
      '<div class="contact">联系方式：' + (procurement.contactMobile || '') + '</div>'
  );
  if (procurement.content && procurement.content.length > 0) {
    htmlText += ('<div class="content">详情：' + procurement.content + '</div>');
  }
  htmlText += '</div>';

  if (procurement.mobile && procurement.mobile.length > 0) {
    htmlText += ('<div class="product-bottom">');
    htmlText += ('<span class="mobile"><img src="/static/image/mobile/call.png" />');
    htmlText += procurement.mobile;
    htmlText += ('</span>');
    htmlText += ('</div>');
  }
  return htmlText;
}
function appendProcurementsToDOM(pageData) {
  var divProductContent = $('.procurement-warpper .supply-content');
  if (divProductContent.length > 0) {
    divProductContent.html('');
    pageData.datas.forEach(procurement => {
      divProductContent.append(convertProcurementData2DOM(procurement));
    });
    var pageElement = $('.procurement-warpper .pagination');
    pagination.appendPageToDOM(pageData, pageElement, bindPageItemClickEvent);
  } else {
    divProductContent = $('.supply-warpper-mobile .supply-list');
    divProductContent.html('');
    pageData.datas.forEach(procurement => {   
      divProductContent.append(convertProcurementData2H5DOM(procurement));
    });
  }
}
/**
 * 动态向产品内容区添加产品
 * @param
 *      PageData
 */
function convertSupplyData2DOM(procurement) {
  let htmlText = '<div class="supply">' +
    '<div class="product-name">' +
      '<span class="supply-time">' + procurement.date + '</span>' +
      '<span class="supply-icon"></span>' +
    '</div>';
  htmlText += ('<div class="product-content">');
  htmlText += (
    '<div class="name">产品名称：' + (procurement.title || '') + '</div>' +
    '<div class="production-place">产品产地：' + (procurement.productionPlace || '') + '</div>' +
    '<div class="amount">产品数量：' + (procurement.amount || '') + '</div>' +
    '<div class="contact">联系方式：' + (procurement.contactMobile || '') + '</div>'
  );
  if (procurement.content && procurement.content.length > 0) {
    htmlText += ('<div class="content">产品介绍：' + procurement.content + '</div>');
  }
  htmlText += '</div>';
  htmlText += (
    '<div class="product-bottom">' +
      '<span style="visibility: hidden"><i class="iconlocation"></i> 广西桂林泰士特</span>' +
      '<span class="mobile" style="visibility:' + (procurement.mobile ? 'visible' : 'hidden') +'"><i class="iconphone"></i>' + procurement.mobile + '</span>' +
    '</div>'
  );
  htmlText += '</div>';
  return htmlText;
};
function convertSupplyData2H5DOM(procurement) {
  let htmlText = '<div class="content-supply">' +
                      '<div class="title-supply">' +
                      '<div class="supply-type-procurement">供</div>' +
                      '<span>' + procurement.title + '</span>' +
                      '<span>' + procurement.date + '</span>' +
                  '</div>';                
  htmlText += (
    '<div class="content-supply">' + 
      '<div class="production-place">产品产地：' + (procurement.productionPlace || '') + '</div>' +
      '<div class="amount">产品数量：' + (procurement.amount || '') + '</div>' +
      '<div class="contact">联系方式：' + (procurement.contactMobile || '') + '</div>'
  );
  if (procurement.content && procurement.content.length > 0) {
    htmlText += ('<div class="content">产品介绍：' + (procurement.content || '') + '</div>');
  }
  htmlText += ('</div>');
  if (procurement.mobile && procurement.mobile.length > 0) {
    htmlText += ('<div class="product-bottom">');
    htmlText += ('<span class="mobile"><img src="/static/image/mobile/call.png" />');
    htmlText += procurement.mobile;
    htmlText += ('</span>');
    htmlText += ('</div>');
  }
  return htmlText;
};
function appendSuppliersToDOM(pageData) {
  var divProductContent = $('.supplier-warpper .supply-content');
  if (divProductContent.length > 0) {
    divProductContent.html('');
    pageData.datas.forEach(supplement => {
      divProductContent.append(convertSupplyData2DOM(supplement));
    });
    var pageElement = $('.supplier-warpper .pagination');
    pagination.appendPageToDOM(pageData, pageElement, bindPageItemClickEvent);
  } else {
    divProductContent = $('.supply-warpper-mobile .supply-list');
    divProductContent.html('');
    pageData.datas.forEach(procurement => {    
      divProductContent.append(convertSupplyData2H5DOM(procurement));
    });
  }
}

/**
 * 从服务器拉取 采购需求列表
 * @param {数据页} nIndex
 * @param {数据请求完成后回调} fn
 */
function onClickedProcurementPageItem(nIndex, fn) {
  $.ajax({
    type: 'GET',
    url: '/supply/getProcurements',
    data: {'pageIndex': nIndex},
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.datas) {
        appendProcurementsToDOM(response.data);
        fn && fn();
      } else {
      }
    }
  });
}
/**
 * 从服务器拉取 供应需求列表
 * @param {数据页} nIndex
 * @param {数据请求完成后回调} fn
 */
function onClickedSupplierPageItem(nIndex, fn) {
  $.ajax({
    type: 'GET',
    url: '/supply/getSuppliers',
    data: {'pageIndex': nIndex},
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.datas) {
        appendSuppliersToDOM(response.data);
        if (fn) {
          fn();
        }
      } else {
      }
    }
  });
}

// 分页器事件绑定
function bindPageItemClickEvent() {
  $('.procurement .procurement-warpper .pagination ul li').each(function(index) {
    const id = $(this).attr('id');
    $(this).click(function() {
      pagination.onClickedPageItem('.procurement .procurement-warpper .pagination', id, onClickedProcurementPageItem);
    });
  });
  $('.supplier .supplier-warpper .pagination ul li').each(function(index) {
    const id = $(this).attr('id');
    $(this).click(function() {
      pagination.onClickedPageItem('.supplier .supplier-warpper .pagination', id, onClickedSupplierPageItem);
    });
  });
}

// 手机端  采购/供应 切换
function onClickedTypeToogle(index) {
  const procurementInputElement = $('.supply-warpper-mobile .procurement-input-panel');
  const supplierInputElement = $('.supply-warpper-mobile .supplier-input-panel');
  if (index === 0) {
    procurementInputElement.css('display', 'block');
    supplierInputElement.css('display', 'none');
    onClickedProcurementPageItem(1);
  } else {
    procurementInputElement.css('display', 'none');
    supplierInputElement.css('display', 'block');
    onClickedSupplierPageItem(1);
  }
}
/**
 * 手机端点击 闪电发布
 * @param
 */
function onClickedMobilePublishRequirement() {
  const displayTipView = require('./common').showToast;

  const name = $('.supply-warpper-mobile .procurement-input-panel #procurement-name').val();
  if (!(name && name.length > 0)) {
    displayTipView('请输入采购产品名称');
    return;
  }
  const amount = $('.supply-warpper-mobile .procurement-input-panel #procurement-amount').val();
  if (!(amount && amount.length > 0)) {
    displayTipView('请输入采购产品数量');
    return;
  }
  const mobile = $('.supply-warpper-mobile .procurement-input-panel #procurement-contact').val();
  if (!(mobile && mobile.length > 0)) {
    displayTipView('请输入联系电话');
    return;
  } else if (!utils.isValidMobile(mobile) && !utils.isValidTelephone(mobile)) {
    displayTipView('请输入有效的联系电话');
    return;
  }
  const description = $('.supply-warpper-mobile .procurement-input-panel #procurement-description').val();
  publishRequirement2Server(1, name, amount, mobile, null, description, function(bResult) {
    if (bResult) {
      $('.supply-warpper-mobile .procurement-input-panel #procurement-description').val('');
      $('.supply-warpper-mobile .procurement-input-panel #procurement-contact').val('');
      $('.supply-warpper-mobile .procurement-input-panel #procurement-amount').val('');
      $('.supply-warpper-mobile .procurement-input-panel #procurement-name').val('');
      displayTipView('添加成功!');
    } else {
      displayTipView('添加失败了！');
    }
  });
}
function onClickedMobilePublishSupply() {
  const displayTipView = require('./common').showToast;

  const name = $('.supply-warpper-mobile .supplier-input-panel #supply-name').val();
  if (!(name && name.length > 0)) {
    displayTipView('请输入供应产品名称');
    return;
  }
  const productionPlace = $('.supply-warpper-mobile .supplier-input-panel #supply-productionPlace').val();
  if (!(productionPlace && productionPlace.length > 0)) {
    displayTipView('请输入产品产地');
    return;
  }
  const amount = $('.supply-warpper-mobile .supplier-input-panel #supply-amount').val();
  if (!(amount && amount.length > 0)) {
    displayTipView('请输入产品数量');
    return;
  }
  const mobile = $('.supply-warpper-mobile .supplier-input-panel #supply-contact').val();
  if (!(mobile && mobile.length > 0)) {
    displayTipView('请输入联系电话');
    return;
  } else if (!utils.isValidMobile(mobile) && !utils.isValidTelephone(mobile)) {
    displayTipView('请输入有效的联系电话');
    return;
  }
  const description = $('.supply-warpper-mobile .supplier-input-panel #supply-description').val();
  if (!(description && description.length > 0)) {
    displayTipView('请输入产品介绍');
    return;
  }
  publishRequirement2Server(2, name, amount, mobile, productionPlace, description, function(bResult) {
    if (bResult) {
      $('.supply-warpper-mobile .supplier-input-panel #supply-description').val('');
      $('.supply-warpper-mobile .supplier-input-panel #supply-contact').val('');
      $('.supply-warpper-mobile .supplier-input-panel #supply-amount').val('');
      $('.supply-warpper-mobile .supplier-input-panel #supply-productionPlace').val('');
      $('.supply-warpper-mobile .supplier-input-panel #supply-name').val('');
      displayTipView('添加成功!');
    } else {
      displayTipView('添加失败了！');
    }
  });
}

function extractNumber(path, length) {
  const val = $(path).val().replace(/[^0-9]/g, '');
  $(path).val(val.slice(0, length));
}

// 点击导航
function supplyNavInit() {
  $('.release-title a').each(function(index) {
    $(this).click(function() {
      $('.release-title a').eq(index).addClass('checked').siblings().removeClass('checked');
      if (index === 0) {
        $('.release .purchase-form').removeClass('no-show');
        $('.release .supply-form').addClass('no-show');
      } else {
        $('.release .supply-form').removeClass('no-show');
        $('.release .purchase-form').addClass('no-show');
      }
    });
  });
  $('.release .release-btn').on('click', onClickedPublishRequirement);
  // $('.release .purchase-form .release-report-row #productCount').on('keyup', function() {
  //   extractNumber('.release .purchase-form .release-report-row #productCount', 10);
  // });
  $('.release .purchase-form .release-report-row #purchase-mobile').on('keyup', function() {
    extractNumber('.release .purchase-form .release-report-row #purchase-mobile', 12);
  });
  // $('.release .supply-form .release-report-row #amount').on('keyup', function() {
  //   extractNumber('.release .supply-form .release-report-row #amount', 10);
  // });
  $('.release .supply-form .release-report-row #mobile').on('keyup', function() {
    extractNumber('.release .supply-form .release-report-row #mobile', 12);
  });
  // 手机端 闪电发布按钮点击
  $('div.supply-warpper-mobile .procurement-input-panel .supply-btn').on('click', onClickedMobilePublishRequirement);
  $('div.supply-warpper-mobile .supplier-input-panel .supply-btn').on('click', onClickedMobilePublishSupply);
  // $('.supply-warpper-mobile .procurement-input-panel #procurement-amount').on('keyup', function() {
  //   extractNumber('.supply-warpper-mobile .procurement-input-panel #procurement-amount', 10);
  // });
  $('.supply-warpper-mobile .procurement-input-panel #procurement-contact').on('keyup', function() {
    extractNumber('.supply-warpper-mobile .procurement-input-panel #procurement-contact', 12);
  });
  // $('.supply-warpper-mobile .supplier-input-panel #supply-amount').on('keyup', function() {
  //   extractNumber('.supply-warpper-mobile .supplier-input-panel #supply-amount', 10);
  // });
  $('.supply-warpper-mobile .supplier-input-panel #supply-contact').on('keyup', function() {
    extractNumber('.supply-warpper-mobile .supplier-input-panel #supply-contact', 12);
  });
}

function supplyContentNavInit() {
  $('.release-content-title a').each(function(index) {
    $(this).click(function() {
      $('.release-content-title a').eq(index).addClass('checked-content').siblings().removeClass('checked-content');
      if (index === 0) {
        $('.procurement').removeClass('content-show');
        $('.supplier').addClass('content-show');
        onClickedProcurementPageItem(1);
      } else {
        $('.supplier').removeClass('content-show');
        $('.procurement').addClass('content-show');
        onClickedSupplierPageItem(1);
      }
    });
  });
  // 分页器事件绑定
  bindPageItemClickEvent();
}

const init = () => {
  supplyNavInit();
  supplyContentNavInit();

  // 手机端点击事件绑定
  $('.supply-warpper-mobile .release-title a').each(function(index) {
    $(this).click(function() {
      onClickedTypeToogle(index);
    });
  });
};
module.exports = { init };

},{"./common":5,"./common/utils":6,"./pagination":13}]},{},[2])

